const taskConfigCommitTypes = {
  SET_TASK_GROUPS_CONFIG: 'SET_TASK_GROUPS_CONFIG',
  SET_TASK_CONFIG_IS_LOADING: 'SET_TASK_CONFIG_IS_LOADING',
  PUSH_TASK_GROUP_CONFIG: 'PUSH_TASK_GROUP_CONFIG',
  PUSH_TASK_CONFIG: 'PUSH_TASK_CONFIG',
  UPDATE_TASK_GROUP_CONFIG: 'UPDATE_TASK_GROUP_CONFIG',
  UPDATE_TASK_CONFIG: 'UPDATE_TASK_CONFIG',
  DELETE_TASK_GROUP_CONFIG: 'DELETE_TASK_GROUP_CONFIG',
  DELETE_TASK_CONFIG: 'DELETE_TASK_CONFIG',
};

export default taskConfigCommitTypes;